import { SpectrumColor } from '../types';

export const Indigo: SpectrumColor = {
  0: '#F7F8FD',
  5: '#F3F5FD',
  10: '#EDEFFB',
  15: '#E4E7F9',
  20: '#DBDFF6',
  25: '#CED2F2',
  30: '#C1C5ED',
  35: '#B5B9E9',
  40: '#A9ADE5',
  50: '#9297DD',
  60: '#727AD7',
  70: '#5E66CE',
  80: '#4D56CA',
  90: '#3841B0',
  100: '#260888',
  110: '#1A2067',
  default: 100,
};
